import type { ReactNode } from 'react';

import { Box, Flex } from '@chakra-ui/react';

import { isDefined, isNotDefined } from '@enterprise/core';
import { DefaultToolTip } from '@enterprise/ui';

import type { ListSegmentCellProps } from './types/list-segment-renderer.params';

function ListSegmentCellRenderer<TData extends object = Record<string, unknown>, TContext = unknown>({
  data,
  header,
  node,
  subHeader,
}: ListSegmentCellProps<TData, TContext>) {
  if (isNotDefined(data)) {
    return null;
  }

  const record = data as Record<string, unknown>;
  const listSegmentValue = isDefined(header) ? (record[header] as ReactNode) : null;
  const listManagerValue = isDefined(subHeader) ? (record[subHeader] as ReactNode) : null;

  return (
    <>
      {node.footer && null}
      {!node.footer && (
        <Flex
          direction="column"
          h="full"
          justify="center"
          lineHeight="initial!"
          w="full">
          <DefaultToolTip
            isDisabled={isNotDefined(listSegmentValue)}
            label={listSegmentValue}>
            <Box isTruncated>{listSegmentValue}</Box>
          </DefaultToolTip>
          {isDefined(listManagerValue) && (
            <DefaultToolTip label={listManagerValue}>
              <Box
                fontSize="xs"
                isTruncated>
                {listManagerValue}
              </Box>
            </DefaultToolTip>
          )}
        </Flex>
      )}
    </>
  );
}

export default ListSegmentCellRenderer;
